



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
    @Prop(String) public icon?: string;
    @Prop({ type: [String, Number] }) public text?: string | number;
    @Prop(String) public title?: string;
    @Prop(Boolean) public isActive?: boolean;

    public get haveListeners(): boolean {
        return Object.keys(this.$listeners).length > 0;
    }
}
